import { LoadingOutlined } from "@ant-design/icons";
import { notification } from 'antd';
import { useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";

const sanitizeValue =  (value) => {
    if(value!=null && value!=undefined && value!="" && value > 0) return value
    return 0
};

const sanitizeObject =  (value) => {
  if(value!=null && value!=undefined && value!="") return value
  return ""
};


const dateFormatDDMMYYYY =  (date,delimeter) => {
    if(date!=null && date!=undefined && date!="") {
        return date.getDate().toString().padStart(2, "0")   + delimeter + (date.getMonth() + 1).toString().padStart(2, "0") + delimeter  + date.getFullYear();  
    }
    else{
        return '';
    }
        
};

const dateFormatYYYYMMDD =  (date,delimeter) => {
  var splitDate = date.split("/")
  let dateN =  new Date(splitDate[2]+"-"+splitDate[1]+"-"+splitDate[0]);
  if(dateN!=null && dateN!=undefined && dateN!="") {
      return dateN.getFullYear() + delimeter + (dateN.getMonth() + 1).toString().padStart(2, "0") + delimeter  + dateN.getDate().toString().padStart(2, "0");  
  }
  else{
      return '';
  }
      
};


const openNotification = (placement,status,messagetext) => {
    notification.info({
      message: `${status}`,
      description:
        `${messagetext}`,
      placement,
    });
  };


  const openNotificationWithType = (type,placement,status,messagetext) => {
    notification[type]({
      message: `${status}`,
      description:
        `${messagetext}`,
      placement,
      duration:0
    });
  };


  const removeEmptyElements = (obj) => {
    if (Array.isArray(obj)) {
      obj.forEach((element, index) => obj.splice(index, 1, removeEmptyElements(element)));
      return obj;
    }
    return Object.fromEntries(Object.entries(obj)
      .filter(([, v]) => (Array.isArray(v) ? v.length !== 0 : (v !== null && v !== '' && v !== undefined)))
      .map(([k, v]) => [k, v === (Object(v)) ? removeEmptyElements(v) : v]));
  }

  const randomID = ()=> {
    return Date.now() + (Math.random() * 100000).toFixed();
  }


const formatStringDate = (date) => {
  let currentDate = new Date(date);
  let pushdate = currentDate.getDate().toString().padStart(2, "0")  + "-" +  (currentDate.getMonth() + 1).toString().padStart(2, "0") + "-" + currentDate.getFullYear();
  return pushdate;
}


const todayDate = (delimeter) => {
  let currentDate = new Date();
  let pushdate = currentDate.getDate().toString().padStart(2, "0")  + delimeter +  (currentDate.getMonth() + 1).toString().padStart(2, "0") + delimeter + currentDate.getFullYear();
  return pushdate;
}


const firstDateOfMonth = (delimeter="/") => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  
  const firstDayOfMonth = new Date(year, month, 1);
  const first_date = commonUtility.dateFormatDDMMYYYY(firstDayOfMonth,delimeter);
  return first_date;
  
}

const lastDateOfMonth = (delimeter="/") => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  
  const lastDayOfMonth = new Date(year, month + 1, 0);
  const last_date = commonUtility.dateFormatDDMMYYYY(lastDayOfMonth,delimeter);
  return last_date;

}

const getMonthYearFromDate =  (date) => {

  let monthNames= ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  if(date!=null && date!=undefined && date!="") {
    let newDate = new Date(date);
    let monthYear=monthNames[newDate.getMonth()] +" "+ newDate.getFullYear();
    return monthYear;
  }
  else{
      return '';
  }
      
};




const allowOnlyNumber = (value) => {
  const result = value.replace(/\D/g, '');
  return result;
}

/*
const getRoundOfAmount = (amount) => {
  let roundOffDetail = {}
  const reminder = amount%10;

  if(reminder>=0 && reminder<5){
    const newPayableAmt = amount-reminder;
    const roundOff = amount-(reminder+amount)
    roundOffDetail = {
      "roundoffAmount" : roundOff.toFixed(2),
      "newPayableAmount" : newPayableAmt,
      "operation" : "-"
    }
  }
  else if(reminder>=5 && reminder<=9){
    const roundOffAmount = 10-reminder;
    const newPayableAmt = amount+roundOffAmount;
  

    roundOffDetail = {
      "roundoffAmount" : roundOffAmount.toFixed(2),
      "newPayableAmount" : newPayableAmt,
      "operation" : "+"
    }
  }

  return roundOffDetail
}
*/

const round2 = (value) => {
  return parseFloat((Math.round((parseFloat(value || 0) + Number.EPSILON) * 100) / 100).toFixed(2));
};

const getRoundOfAmount = (amount) => {
  let roundOffDetail = {}
  
  const cleanAmount = round2(amount);
  const newPayableAmt = Math.round(cleanAmount);
  let roundOffAmount = round2(newPayableAmt - cleanAmount);

  if (Object.is(roundOffAmount, -0) || Math.abs(roundOffAmount) < 0.0001) {
    roundOffAmount = 0;
  }

  if(roundOffAmount < 0){
    roundOffDetail = {
      "roundoffAmount" : roundOffAmount.toFixed(2),
      "newPayableAmount" : newPayableAmt,
      "operation" : "-"
    }
  }
  else {
    roundOffDetail = {
      "roundoffAmount" : roundOffAmount.toFixed(2),
      "newPayableAmount" : newPayableAmt,
      "operation" : "+"
    }
  }

  return roundOffDetail
}

const addMonthsToDate = (numOfMonths, date = new Date()) => {
    // For Tap Membership validity
//  date.setMonth(date.getMonth() + numOfMonths);
  
    const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1 , 0);
    const endOfValidity = new Date(endOfMonth.getFullYear(), endOfMonth.getMonth() + numOfMonths, 0);
    console.log(`${date.toLocaleDateString()} to ${endOfValidity.toLocaleDateString()}`);

  //let pushdate = date.getDate().toString().padStart(2, "0")  + "/" +  (date.getMonth() + 1).toString().padStart(2, "0") + "/" + date.getFullYear();
  let pushdate = endOfValidity.getDate().toString().padStart(2, "0")  + "/" +  (endOfValidity.getMonth() + 1).toString().padStart(2, "0") + "/" + endOfValidity.getFullYear();

  return pushdate;
}

const isLoggedIn = () => {
  const localstorage = JSON.parse(localStorage.getItem('user'));
  if(localstorage!=null && localstorage){
      return true;
  }
  return false;
}

const getLoggedInUserInfo = () => {
  let userInfo = null;
  let userInfoDecrypted = null;
  if(isLoggedIn()){
    userInfo = JSON.parse(localStorage.getItem('user'));
    if(userInfo.token != null) {
      userInfoDecrypted = jwt_decode(userInfo.token);
    }
    else{
      userInfoDecrypted = null;
    }
    
  }
  return userInfoDecrypted;
}

const isTokenExpired = () => {
  const tokenExpireTime = commonUtility?.getLoggedInUserInfo()?.exp * 1000;
  if(tokenExpireTime < Date.now()) {
    return true;
  } else {
    return false;
  }
}

const extractTextContent = (element) => {
  console.log('element.props.children',element);
  if (typeof element === 'string') {
    return element;
  }

  if (Array.isArray(element?.children)) {
    return element?.children?.map(extractTextContent).join(' ');
  }

  return extractTextContent(element.children);
};


const openInNewTab = (url) => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
  if (newWindow) newWindow.opener = null
}

const checkEmpty =  (value) => {
  if(value!=null && value!=undefined && value!="") return true
  return false
};

const commonUtility = {
    sanitizeValue,
    sanitizeObject,
    dateFormatDDMMYYYY,
    dateFormatYYYYMMDD,
    openNotification,
    removeEmptyElements,
    randomID,
    formatStringDate,
    round2,
    getRoundOfAmount,
    todayDate,
    allowOnlyNumber,
    getMonthYearFromDate,
    addMonthsToDate,
    isLoggedIn,
    openNotificationWithType,
    getLoggedInUserInfo,
    firstDateOfMonth,
    lastDateOfMonth,
    isTokenExpired,
    extractTextContent,
    openInNewTab,
    checkEmpty
};

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

export default commonUtility;